/// <amd-module name="PipelinesUI/Utilities/LogParser" />

import { Parser} from "./Parser";
import { IParser, ILine } from "./LogParser.Types";

export class LogParser implements IParser {
    protected _parser = new Parser();
    public parse(content: string, startIndex?: number, linesLength?: number): ILine[] {
        return this._parser.parseLines(content, startIndex, linesLength);
    }
}
